var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"marketing-layout"}},[_c('MarketingHeader'),_c('main',{staticClass:"flex-grow-1"},[_c('router-view')],1),_c('MarketingFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }